import { getData } from "./apiUtils";
import * as CONFIG from '../utils/config'

export function getTemplatePreviewData(id) {
    return getData(CONFIG.GET_TEMPLATE_PREVIEW_DATA_URL() + id);
}

export function getAllPageNamesAndUrls() {
    return getData(CONFIG.GET_ALL_PAGES_URL());
}
